import {
    Column,
    Format,
    Lookup
} from 'devextreme-react/data-grid';

import { useGetActionRequiredOrders } from "../api/get-action-required-orders";
import { ActionRequiredGridProps } from '../types/ActionRequiredGridProps';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { formatShortTime } from '../../../../utils/date-utils';

export default function ActionRequiredGrid(props: ActionRequiredGridProps) {
    const orders = useGetActionRequiredOrders(props.actionRequiredID, props.pastDueOnly, props.activeOnly);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    return (
        <>
            <SyncDataGrid
                stateStorageKey={'dealer-action-required-orders-v2-' + props.actionRequiredID}
                className={'dx-card wide-card action-required-grid'}
                dataSource={orders.data?.orders}
                keyExpr={['actionRequiredID', 'orderID']}
                height="68vh"
            >
                <Column
                    dataField={'orderNumber'}
                    caption={'Order #'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/dealer/retail-order/${row.data.orderID}?returnUrl=${returnUrl}`}>
                            {row.data.orderNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'date'}
                    caption={'Customer Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'orderType'}
                    caption={'Order Type'}
                    dataType="string"
                />
                <Column
                    dataField={'actionRequiredID'}
                    caption={'Action Required'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/dealer/retail-order/${row.data.orderID}?returnUrl=${returnUrl}`}>
                            {row.data.actionDescription}
                        </Link>;
                    }}
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 250
                        }
                    }}
                >
                    <Lookup
                        dataSource={orders.data?.actionsRequired}
                        valueExpr={'actionRequiredID'}
                        displayExpr={'description'}
                    />
                </Column>
                <Column
                    dataField={'actionRequiredStatusID'}
                    calculateDisplayValue={'actionRequiredStatus'}
                    caption={'AR Status'}
                    dataType="string"
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 150,
                        }
                    }}                >
                    <Lookup
                        dataSource={orders.data?.arStatuses}
                        valueExpr={'lookupID'}
                        displayExpr={'displayValue'}
                    />
                </Column>
                <Column
                    dataField={'amount'}
                    caption={'Order Amount'}
                    dataType="number"
                    editorOptions={{ format: '$#,##0.##', showClearButton: true }}
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'cabinetFlag'}
                    caption={'Cabinets'}
                    dataType="boolean"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 150
                        }
                    }}
                >
                    <Lookup
                        dataSource={orders.data?.productLines}
                        valueExpr={'description'}
                        displayExpr={'description'}
                    />
                </Column>
                <Column
                    dataField={'dealerStoreNo'}
                    caption={'Store #'}
                    visible={orders.data?.showDealerStore}
                    dataType="string"
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />
                <Column
                    dataField={'userName'}
                    caption={'User'}
                    dataType="string"
                />
                <Column
                    dataField={'lastUpdatedDate'}
                    caption={'Date'}
                    dataType="date"
                />
                <Column
                    caption={'Time'}
                    dataType="string"
                    calculateDisplayValue={(row) => { return formatShortTime(row.lastUpdatedDate) }}
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
